import { render, staticRenderFns } from "./RepeaterLabel.vue?vue&type=template&id=666e0e5a"
import script from "./RepeaterLabel.vue?vue&type=script&lang=js"
export * from "./RepeaterLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports